import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class ResidentialCanteenAddressesApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/residential-canteen-addresses'
    }
}

export default new ResidentialCanteenAddressesApiClient()
